import React from 'react';
import { motion } from 'framer-motion';
import { HexShape } from './HexagonLogo';

export function MarqueeText({ texts = [], speed = 30, reverse = false }) {
  const items = [...texts, ...texts, ...texts];

  return (
    <div style={styles.marqueeWrap}>
      <motion.div
        style={styles.marqueeTrack}
        animate={{ x: reverse ? ['0%', '-33.33%'] : ['-33.33%', '0%'] }}
        transition={{ duration: speed, repeat: Infinity, ease: 'linear' }}
      >
        {items.map((text, i) => (
          <React.Fragment key={i}>
            <span style={styles.marqueeItem}>{text}</span>
            <span style={styles.marqueeDot}>
              <HexShape size={20} color="#3E7562" opacity={0.4} />
            </span>
          </React.Fragment>
        ))}
      </motion.div>
    </div>
  );
}

export function MarqueeImages({ images = [], speed = 40, reverse = false }) {
  const items = [...images, ...images, ...images];

  return (
    <div style={styles.marqueeWrap}>
      <motion.div
        style={{ ...styles.marqueeTrack, gap: 16 }}
        animate={{ x: reverse ? ['0%', '-33.33%'] : ['-33.33%', '0%'] }}
        transition={{ duration: speed, repeat: Infinity, ease: 'linear' }}
      >
        {items.map((img, i) => (
          <div key={i} style={styles.marqueeImageWrap}>
            <div style={{
              width: 280,
              height: 180,
              background: `linear-gradient(135deg, rgba(62, 117, 98, ${0.08 + (i % 4) * 0.04}) 0%, rgba(6, 43, 30, 0.1) 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(62, 117, 98, 0.1)',
            }}>
              <span style={{ color: '#549E84', fontSize: '0.8rem', fontWeight: 500, opacity: 0.6 }}>{img}</span>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
}

const styles = {
  marqueeWrap: {
    width: '100%',
    overflow: 'hidden',
    padding: '24px 0',
  },
  marqueeTrack: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    whiteSpace: 'nowrap',
    width: 'fit-content',
  },
  marqueeItem: {
    fontSize: 'clamp(2.5rem, 6vw, 5rem)',
    fontWeight: 800,
    fontFamily: "'Montserrat', sans-serif",
    color: 'transparent',
    WebkitTextStroke: '1.5px rgba(255, 255, 255, 0.12)',
    padding: '0 24px',
    textTransform: 'uppercase',
    letterSpacing: '-2px',
    flexShrink: 0,
  },
  marqueeDot: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    flexShrink: 0,
  },
  marqueeImageWrap: {
    flexShrink: 0,
  },
};
